import React, { type FC } from "react";
import { LandingContainer } from "../components/LandingContainer";

export const LandingPage: FC = () => {
	return (
		<LandingContainer size="lg">
			<h1 className="display-1 display-bold mb-4">Elérhetőségeink</h1>
			<p>A Bankmonitor.hu weboldal üzemeltetője a</p>
			<h2 className="h1 mb-lg-4 mb-md-3 mb-2">Bankmonitor Kft.</h2>
			<p>
				1037 Budapest, Montevideo utca 16/B.
				<br />
				Adószáma: 23745025-2-41
				<br />
				Cg.: 01-09-976265
			</p>
			<p>
				E-mail: <a href="mailto:bankmonitor@bankmonitor.hu">bankmonitor@bankmonitor.hu</a>
			</p>
			<p>
				<b>A média érdeklődéseit</b> interjú, szakmai kommentár, banki adatok, termék adatbázisok,
				összehasonlítások ügyében az alábbi e-mail címen várjuk:
				<br />
				<a href="mailto:sajto@bankmonitor.hu">sajto@bankmonitor.hu</a>
			</p>
			<p>
				Részletes bemutatkozást a <a href="/rolunk/?link_type=landing-link">Rólunk</a> menüpontban talál.
			</p>
			<p>
				Promóciós, vagy további együttműködési lehetőségekről a{" "}
				<a href="/mediaajanlat/?link_type=landing-link">média ajánlat</a> oldalunkon olvashat.
			</p>
		</LandingContainer>
	);
};
